var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "VisitorForm",
      staticClass: "visitor-step-1 visitor-step-1-theme",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { ref: "scrollDiv", staticClass: "visitor-step-1-inner" }, [
        _c("div", { staticClass: "visitor-step-1-login" }, [
          _c("a", { on: { click: _vm.login } }, [
            _vm._v("\n        " + _vm._s(_vm.$t("visitorLogin")) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "visitor-step-1-header" }, [
          _c("span", {
            staticClass: "visitor-step-1-header-text",
            domProps: { innerHTML: _vm._s(_vm.visitorWelcomeText) },
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "visitor-step-1-header-img",
            attrs: { src: _vm.visitorImage, alt: "hand-image" },
          }),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "visitor-step-1-desc" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("visitorLeaveDataReason")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "visitor-label-wrapper" }, [
          _c(
            "label",
            { staticClass: "visitor-label" },
            [
              _c("input-index", {
                staticClass: "visitor-input",
                attrs: {
                  type: "text",
                  value: _vm.visitorForm.input.name.value,
                  placeholder: _vm.$t("name") + "*",
                },
                on: {
                  input: function ($event) {
                    _vm.visitorForm.input.name.value = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasFormSubmitted
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.formError.nameRequired,
                      expression: "formError.nameRequired",
                    },
                  ],
                  staticClass: "visitor-input-error",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("TheFieldIsRequired")) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "visitor-label-blank" }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "visitor-label" },
            [
              _c("input-index", {
                staticClass: "visitor-input",
                attrs: {
                  type: "email",
                  value: _vm.visitorForm.input.email.value,
                  placeholder: _vm.$t("email") + "*",
                },
                on: {
                  input: function ($event) {
                    _vm.visitorForm.input.email.value = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasFormSubmitted
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.formError.emailRequired ||
                        _vm.formError.emailFormatInvalid,
                      expression:
                        "formError.emailRequired || formError.emailFormatInvalid",
                    },
                  ],
                  staticClass: "visitor-input-error",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.formError.emailRequired
                          ? _vm.$t("TheFieldIsRequired")
                          : _vm.formError.emailFormatInvalid
                          ? _vm.$t("IncorrectFormat")
                          : ""
                      ) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "visitor-label-blank" }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "visitor-label" },
            [
              _c("input-index", {
                staticClass: "visitor-input",
                attrs: {
                  type: "password",
                  value: _vm.visitorForm.input.password.value,
                  placeholder: _vm.$t("general.password") + "*",
                  autocomplete: "new-password",
                },
                on: {
                  input: function ($event) {
                    _vm.visitorForm.input.password.value = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasFormSubmitted
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.formError.passwordRequired ||
                        _vm.formError.passwordFormatInvalid,
                      expression:
                        "formError.passwordRequired || formError.passwordFormatInvalid",
                    },
                  ],
                  staticClass: "visitor-input-error",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.formError.passwordRequired
                          ? _vm.$t("TheFieldIsRequired")
                          : _vm.formError.passwordFormatInvalid
                          ? _vm.$t("general.minLength", { n: 6 })
                          : ""
                      ) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "visitor-label-blank" }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "visitor-label" },
            [
              _c("input-index", {
                staticClass: "visitor-input",
                attrs: {
                  type: "text",
                  value: _vm.visitorForm.input.phone.value,
                  placeholder: _vm.$t("phone") + "*",
                },
                on: {
                  input: function ($event) {
                    _vm.visitorForm.input.phone.value = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasFormSubmitted
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.formError.phoneRequired ||
                        _vm.formError.phoneFormatInvalid,
                      expression:
                        "formError.phoneRequired || formError.phoneFormatInvalid",
                    },
                  ],
                  staticClass: "visitor-input-error",
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.formError.phoneRequired
                          ? _vm.$t("TheFieldIsRequired")
                          : _vm.formError.phoneFormatInvalid
                          ? _vm.$t("IncorrectFormat")
                          : ""
                      ) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "visitor-label-blank" }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "visitor-label" },
            [
              _c("input-index", {
                staticClass: "visitor-input",
                attrs: {
                  type: "text",
                  value: _vm.visitorForm.input.occupation.value,
                  placeholder: _vm.$t("occupation"),
                },
                on: {
                  input: function ($event) {
                    _vm.visitorForm.input.occupation.value = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "visitor-label-blank" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "visitor-checkbox-wrapper" }, [
          _c(
            "div",
            [
              _c(
                "Checkbox",
                {
                  staticClass: "visitor-checkbox",
                  attrs: { value: _vm.visitorForm.checkbox.agreement.value },
                  on: {
                    change: function ($event) {
                      _vm.visitorForm.checkbox.agreement.value = $event
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "agreement-text",
                    domProps: { innerHTML: _vm._s(_vm.visitorAgreement1) },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "Checkbox",
                {
                  staticClass: "visitor-checkbox",
                  attrs: { value: _vm.visitorForm.checkbox.agreePolicy.value },
                  on: {
                    change: function ($event) {
                      _vm.visitorForm.checkbox.agreePolicy.value = $event
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass: "agreement-text",
                    domProps: { innerHTML: _vm._s(_vm.visitorAgreement2) },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasFormSubmitted
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.formError.agreeLicenseRequired,
                      expression: "formError.agreeLicenseRequired",
                    },
                  ],
                  staticClass: "visitor-input-error-wrapper",
                },
                [
                  _c("i", {
                    staticClass: "isif isif-warn visitor-input-error-icon",
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "visitor-input-error" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("YouMustAgreeLicense")) +
                        "\n        "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "visitor-step-1-btn-wrapper" }, [
        _vm.error
          ? _c("span", { staticClass: "visitor-input-error" }, [
              _vm._v("\n      " + _vm._s(_vm.error) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "visitor-step-1-btn",
            attrs: { type: "submit", disabled: _vm.busy },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("Submit")) + "\n    ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }